"use strict";
const config_1 = require('./config');
let Raven;
if (typeof window !== 'undefined') {
    Raven = require('raven-js');
}
class SentryClient {
    constructor() {
        this.isInitialized = false;
    }
    initialize() {
        if (Raven && config_1.default.sentry && config_1.default.sentry.dsn) {
            Raven.config(config_1.default.sentry.dsn).install();
            Raven.setExtraContext({
                'my-minutes-commit-hash': __COMMIT_HASH__,
                'my-minutes-version': __VERSION__,
            });
            this.isInitialized = true;
        }
    }
    captureException(e, extra = {}) {
        /*eslint no-console:0*/
        window.console && console.error && console.error(e);
        if (this.isInitialized) {
            Raven.captureException(e, { extra });
        }
    }
    captureBreadcrumb(crumb) {
        if (this.isInitialized) {
            Raven.captureBreadcrumb(crumb);
        }
    }
    setUserContext(context = undefined) {
        if (this.isInitialized) {
            Raven.setUserContext(context);
        }
    }
}
const instance = new SentryClient();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = instance;
exports.breadcrumbBuilder = (store) => next => action => {
    instance.captureBreadcrumb({
        message: action.type,
        data: action,
        category: 'action',
        level: 'info',
    });
    next(action);
};



/** WEBPACK FOOTER **
 ** ./src/sentryClient.ts
 **/